const ERR_CODE_PATTERN = /ERR-(\d+)/i;
const ERR_CODE_MESSAGE_PATTERN = /ERR-\d+\s*:\s*(.+)/i;

const KNOWN_ERR_MESSAGES: Record<string, string> = {
  "011": "Превышено максимальное количество неудачных попыток входа",
  "012": "Пароль истек. Сбросьте пароль.",
  "ZERO-TARIFF-ONCE":
    "Бесплатный тариф можно подключить только один раз и только на месяц",
};

type ApiErrorData = {
  code?: string;
  message?: string;
};

const getApiErrorData = (err: unknown): ApiErrorData | undefined =>
  (err as { response?: { data?: ApiErrorData } })?.response?.data;

export const getRawApiErrorMessage = (err: unknown): string | undefined => {
  const data = getApiErrorData(err);
  const raw = data?.message || (err as { message?: string })?.message;
  return typeof raw === "string" && raw.trim() ? raw : undefined;
};

export const apiErrorHasCode = (err: unknown, code: string): boolean => {
  const data = getApiErrorData(err);
  const normalized = code.toUpperCase();
  if (typeof data?.code === "string" && data.code.toUpperCase().includes(normalized)) {
    return true;
  }
  const message = getRawApiErrorMessage(err);
  return typeof message === "string" && message.toUpperCase().includes(normalized);
};

const resolveKnownErrMessage = (value: string): string | null => {
  const upper = value.toUpperCase();
  if (upper.includes("ZERO-TARIFF-ONCE")) {
    return KNOWN_ERR_MESSAGES["ZERO-TARIFF-ONCE"];
  }
  const match = ERR_CODE_PATTERN.exec(value);
  if (!match?.[1]) return null;
  return KNOWN_ERR_MESSAGES[match[1]] ?? null;
};

export const formatApiErrorMessage = (message: string): string => {
  const trimmed = message.trim();
  const known = resolveKnownErrMessage(trimmed);
  if (known) {
    return known;
  }

  const match = ERR_CODE_MESSAGE_PATTERN.exec(trimmed);
  if (match?.[1]) {
    const extracted = match[1].trim();
    if (extracted) {
      return extracted;
    }
  }
  return trimmed;
};

export const getApiErrorMessage = (err: unknown, fallback: string): string => {
  const data = getApiErrorData(err);

  if (typeof data?.code === "string" && data.code.trim()) {
    const knownFromCode = resolveKnownErrMessage(data.code);
    if (knownFromCode) {
      return knownFromCode;
    }
  }

  const raw = getRawApiErrorMessage(err);
  if (raw) {
    return formatApiErrorMessage(raw);
  }

  return fallback;
};
